import QrCodeGet from './QrCodeGet'

import add from '../Images/add.png'
import mobile from '../Images/mobile.png'
import password from '../Images/password.png'
import barcode from '../Images/barcode.png'
import barcode2 from '../Images/barcodecolor2.png'
import person from '../Images/person.png'
import gift from '../Images/gift.png'
import React, { useContext, useEffect, useState, useRef } from "react";
import { Link, useLocation, useSearchParams, useParams, useNavigate } from 'react-router-dom';
import http from "../Services/httpService";
import Services from "../Services/Services";
import { toast } from "react-toastify";

export default function QrCodeNew() {
    let navigate = useNavigate();
    const formRef = useRef(null);

    const [form, setForm] = useState(
        {
            name: "", code: "", comment: "", price: null,
        });

    useEffect(() => {
        const jwt = http.getLocalJwt();
        if (!jwt || jwt == "") {
            navigate('/login');
        }

    }, []);


    const [isPosting, setIsPosting] = useState(false)
    const handlePosting = async (e) => {
        e.preventDefault();
        const forms = formRef.current;
        if (forms.checkValidity() === false) {
            toast.error('داده های ورودی را بررسی بفرمایید', { theme: "colored" });
            forms.classList.add('was-validated')
            return;
        }
        setIsPosting(true);
        await Services.QrCodeNew1(form)
            .then(({ data }) => {
                setIsPosting(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                navigate('/main');
            })
            .catch(err => {
                setIsPosting(false);
            });
    }
    const [showQrCodeGet, setShowQrCodeGet] = useState(false)
    const [isBusy, setIsBusy] = useState(false)
    const choiceBarcode = (e) => {
        setShowQrCodeGet(false);
    }
    return (
        <>
            {showQrCodeGet &&
                <QrCodeGet
                    isBusy={isBusy}
                    handleClose={e => { setShowQrCodeGet(false) }}
                    show={showQrCodeGet}
                    onChoice={choiceBarcode} />
            }
            <div className="row mb-2">
                <div className="col d-flex justify-content-center">
                    <span className="text-white"> ثبت اطلاعات برچسب</span>
                </div>
            </div>

            <form ref={formRef} className=" needs-validation">
                <div className="row mb-2">
                    <div className="col p-3 ">
                        <div id="boxBarcode" className="d-flex p-2 align-items-center">
                            <div>
                                <img src={barcode} className='me-2' onClick={e => {
                                    e.preventDefault();
                                    setShowQrCodeGet(true);
                                }} />
                            </div>
                            <div className="text-white mx-1  text-nowrap">شماره برچسب :</div>
                            <input
                                id="inputBarCode"
                                asp-for="code"
                                type="text"
                                name="code"
                                value={form.code}
                                onChange={e => http.handleChange(e, form, setForm)}
                                className="form-control"
                                placeholder="وارد کنید"
                                required
                                autoComplete="off"
                            />
                        </div>
                    </div>
                </div>
                <div className="input-group mb-3">
                    <div className="input-group-text" >
                        <img
                            src={person}
                            className=" " />
                    </div>
                    <input
                        asp-for="name"
                        type="text"
                        name="name"
                        value={form.name}
                        onChange={e => http.handleChange(e, form, setForm)}
                        className="form-control"
                        placeholder="عنوان برای بارکد (اختیاری)"
                        autoComplete="off" />
                    <span
                        asp-validation-for="name"
                        className="text-danger" />
                </div>

                <div className="input-group mb-3">
                    <div className="input-group-text" >
                        <img
                            src={gift}
                            className=" " />
                    </div>
                    <input
                        asp-for="price"
                        type="text"
                        name="price"
                        value={form.price}
                        onChange={e => http.handleChange(e, form, setForm)}
                        className="form-control"
                        placeholder="مبلغ مژدگانی (اختیاری)"
                        autoComplete="off" />
                    <span
                        asp-validation-for="price"
                        className="text-danger" />
                </div>
                <div className="input-group mb-3">
                    <textarea
                        asp-for="comment"
                        type="text"
                        name="comment"
                        value={form.comment}
                        onChange={e => http.handleChange(e, form, setForm)}
                        className="form-control"
                        placeholder="توضیحات (اختیاری)"
                        rows={3}
                        autoComplete="off" />
                    <span
                        asp-validation-for="price"
                        className="text-danger" />
                </div>

                <div className='row'>
                    <div className='col'>
                        <button
                            className="w-100 btn btn-lg btn1 py-3"
                            onClick={handlePosting}
                            disabled={isPosting}>
                            <img src={add} className="me-2" /> ثبت
                            {isPosting &&
                                <div className="spinner-border spinner-border-sm" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>}
                        </button>
                    </div>
                    <div className='col'>
                        <button
                            className="w-100 btn btn-lg btn2 py-3 text-decoration-none"
                            onClick={e => {
                                e.preventDefault();
                                setShowQrCodeGet(true);
                            }}
                        >
                            <img src={barcode2} className='me-2' /> اسکن
                        </button>
                    </div>
                </div>
            </form>

            <div className="row mt-4">
                <div className="col d-flex justify-content-center">
                    <Link
                        className="textColor1 text-decoration-none ms-1"
                        to="/main"> لیست برچسب ها</Link>
                </div>
            </div>
        </>

    );

}
